import { CloseOutlined } from "@ant-design/icons";
import { useSearchParams } from "react-router-dom";
import { ProjectRelatedTabs } from "@/features/project-related-tabs";
import type { DocumentPackage } from "@/features/supervision-cards-list";
import { NotificationHistoryContent } from "./ui/notification-history-content";
import { NotificationRelatedContent } from "./ui/notification-related-content";
import { NotificationViewContent } from "./ui/notification-view-content";
import "./notification-view-modal.scss";

export const NotificationViewModal = ({
  packages,
}: {
  packages: DocumentPackage[];
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const isOpen = !!searchParams.get("notificationId");
  const id = searchParams.get("notificationId") || "";
  const modalTab = searchParams.get("modalTab") || "messages";
  const current = packages.find((p) => p.id === id);

  const handleClose = () => {
    const params = new URLSearchParams(searchParams);
    params.delete("notificationId");
    setSearchParams(params);
  };

  if (!isOpen) return null;

  return (
    <div className="journal-object-wrapper">
      <div className="journal-object-container">
        <div className="journal-object-container-form">
          <ProjectRelatedTabs
            tabs={["messages", "related", "history"]}
            tabsTranslate={["Сообщение", "Связанные сообщения", "История"]}
            activeTab={modalTab}
            setActiveTab={(tab: string) => {
              const params = new URLSearchParams(searchParams);
              params.set("modalTab", tab);
              setSearchParams(params);
            }}
          />

          {current && modalTab === "messages" && <NotificationViewContent item={current} />}
          {current && modalTab === "related" && <NotificationRelatedContent item={current} allPackages={packages} />}
          {current && modalTab === "history" && <NotificationHistoryContent />}
        </div>

        <CloseOutlined className="object-form-icon-close" onClick={handleClose} />
      </div>
    </div>
  );
};


